import {createActions} from 'client/framework';

const normalActions = ['SET_ENABLED'];

const eliminationToolActions = createActions(null, normalActions);
export default eliminationToolActions;
